import { useState } from 'react'
import { Logo } from './Frame'
import { Circle } from './motion'
import { useFirstRun } from './store'
import { Button, GoogleG, Input, MicrosoftM } from './ui'

/**
 * The first screen: one line, two sign-in buttons, an email. Google or
 * Microsoft sign-in also connects the calendar, so that step is skipped.
 */
export const Welcome = () => {
   const { signIn } = useFirstRun()
   const [email, setEmail] = useState('')
   const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
   return (
      <div className="fr fixed inset-0 overflow-hidden flex flex-col" data-testid="welcome">
         <header className="h-[84px] shrink-0 flex items-center px-[30px]">
            <Logo />
         </header>
         <main className="flex-1 min-h-0 flex items-center justify-center px-6">
            <div className="w-full max-w-[400px] -mt-8 flex flex-col items-center text-center">
               <Circle kind="launch" />
               <h1 className="fr-title mt-5 text-[34px] md:text-[40px] leading-[1.1] font-semibold tracking-[-0.02em] [text-wrap:balance]">Let’s get your leads called.</h1>
               <p className="mt-3 text-[16px] leading-6 text-[var(--fr-text-2)] max-w-[36ch]">Connect Follow Up Boss, confirm a few things, and your first campaign is calling in under three minutes.</p>
               <div className="mt-7 w-full space-y-3">
                  <Button variant="outline" size="lg" full onClick={() => signIn('google')} testId="continue-google"><GoogleG /> Continue with Google</Button>
                  <Button variant="outline" size="lg" full onClick={() => signIn('microsoft')} testId="continue-microsoft"><MicrosoftM /> Continue with Microsoft</Button>
                  <div className="flex items-center gap-3 py-1"><span className="h-px flex-1 bg-[var(--fr-border)]" /><span className="text-[12px] text-[var(--fr-text-3)]">or</span><span className="h-px flex-1 bg-[var(--fr-border)]" /></div>
                  <Input value={email} onChange={setEmail} placeholder="Your work email" size="lg" type="email" onEnter={() => valid && signIn('email', email)} testId="welcome-email" align="center" />
                  <Button size="lg" full disabled={!valid} onClick={() => signIn('email', email)} testId="continue-email">{valid ? 'Continue with email' : 'Enter your email to continue'}</Button>
               </div>
               <p className="mt-5 text-[12px] text-[var(--fr-text-3)]">Google and Microsoft sign-in also connect your calendar. By continuing you agree to the Terms and Privacy Policy.</p>
            </div>
         </main>
      </div>
   )
}
